import { render } from "./Index.vue?vue&type=template&id=a7522fd2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=a7522fd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7522fd2"

export default script